import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { CircularProgress } from "@mui/material";
import Button from "../../Subcomponents/Button";
import usePaymentConsent from "./usePaymentConsent";
import { CONSENT_TYPES, getConsentStatus, subscribeConsent } from "../../Services/Consent";
import cssClasses from "./VirtualAccountConsentGate.module.css";

// Shows its children (the virtual account details) only when no Virtual Account consent
// is added in the Sales App or this lead has already accepted it. Otherwise shows
// a "Generate Virtual Account" button that runs the T&C + OTP consent first.
export default function VirtualAccountConsentGate({ children }) {
	const loggedInUser = useSelector((state) => state.Auth.user);
	const leadId = loggedInUser?.leadId;
	const { requireConsent, consentModal } = usePaymentConsent();
	const [status, setStatus] = useState("loading"); // loading | locked | open | error

	function loadStatus() {
		setStatus("loading");
		getConsentStatus(leadId, CONSENT_TYPES.VIRTUAL_ACCOUNT)
			.then((res) => setStatus(res.required ? "locked" : "open"))
			.catch((err) => {
				console.error("virtual account consent status error:", err);
				setStatus("error");
			});
	}

	useEffect(() => {
		loadStatus();
		// Unlock every VA card on screen once the consent is accepted in any of them
		return subscribeConsent((acceptedLeadId, type) => {
			if (acceptedLeadId === leadId && type === CONSENT_TYPES.VIRTUAL_ACCOUNT) setStatus("open");
		});
	}, [leadId]);

	if (status === "open") return children;

	return (
		<div className={cssClasses.locked}>
			{status === "loading" ? (
				<CircularProgress size={24} />
			) : (
				<>
					<span className={cssClasses.lock}>
						<svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#155EEF" strokeWidth="1.8">
							<rect x="4" y="10" width="16" height="11" rx="2.5" />
							<path d="M8 10V7a4 4 0 0 1 8 0v3" />
							<circle cx="12" cy="15.5" r="1.4" fill="#155EEF" />
						</svg>
					</span>
					<div className={cssClasses.title}>Virtual account details are hidden</div>
					<div className={cssClasses.text}>
						{status === "error"
							? "Unable to load the virtual account terms. Please try again."
							: "Accept the virtual account terms with an OTP to see your account number, IFSC and beneficiary name."}
					</div>
					<Button
						style={{
							width: "fit-content",
							color: "#fff",
							backgroundColor: "#155EEF",
							border: "1px solid #155EEF",
							fontSize: "1.4rem",
							lineHeight: "2rem",
						}}
						btnName={status === "error" ? "Retry" : "Generate Virtual Account"}
						clicked={() => {
							if (status === "error") {
								loadStatus();
								return;
							}
							requireConsent(CONSENT_TYPES.VIRTUAL_ACCOUNT, () => setStatus("open"), {
								summary: [
									["Request", "View virtual account"],
									["Customer", `${loggedInUser?.personId?.name || ""} · ${loggedInUser?.leadDisplayId || ""}`],
								],
							});
						}}
					/>
				</>
			)}
			{consentModal}
		</div>
	);
}
